<template>
  <div class="simple-list-page">
    <ad-block/>
    <h2>Автоматический генератор ссылок по ГОСТ онлайн</h2>
    <simple-list-container
    ></simple-list-container>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import SimpleListContainer from '@/components/SimpleListContainer.vue'
import FooterBar from '@/components/FooterBar.vue'
import AdBlock from '@/components/AdBlock.vue'
export default {
  name: 'ListPage',
  components: {
    AdBlock,
    SimpleListContainer,
    FooterBar
  }
}
</script>

<style lang="sass" scoped>
h2
  text-align: left
  margin-bottom: 35px
  color: #3949ab
.simple-list-page
  padding: 50px 20px
</style>


// WEBPACK FOOTER //
// SimpleListPage.vue?615d32e0